<template lang="pug">
  .dashboard-quick-actions
    v-card.mx-4.pa-4(flat outlined style="border: 1px solid var(--v-primary200);")
      .h6.basic1000--text {{ $t('quick_action') }}
      v-layout.py-4
        v-spacer
        v-card.text-center.elevation-5.clickable(width="80px")
          div.pa-4(@click="showAddIncomeDialog = true")
            v-layout
              v-card.elevation-0.mx-auto
                v-img(:src="require('@/assets/images/icon_income.png')" width=40)
            //.c1.mt-2 {{ $t('record') }}
            .c1.mt-1 {{ $t('income') }}
        v-spacer
        v-card.text-center.elevation-6.clickable(width="80px")
          div.pa-4(@click="showAddExpenseDialog = true")
            v-layout
              v-card.elevation-0.mx-auto
                v-img(:src="require('@/assets/images/icon_expense.png')" width=40)
            //.c1.mt-2 {{ $t('record') }}
            .c1.mt-1 {{ $t('expense') }}
        v-spacer
        v-card.text-center.elevation-6.clickable(width="80px")
          div.pa-4(@click="showSendReminderDialog = true")
            v-layout
              v-card.elevation-0.mx-auto
                v-img(:src="require('@/assets/images/icon_payment.png')" width=40)
            //.c1.mt-2 {{ $t('collect') }}
            .c1.mt-1 {{ $t('payment') }}
        v-spacer

    .modals
      AddIncome(v-if="showAddIncomeDialog" :open.sync="showAddIncomeDialog" @added="$emit('added', $event)")
      AddExpense(v-if="showAddExpenseDialog" :open.sync="showAddExpenseDialog" @added="$emit('added', $event)")
      SendReminder(v-if="showSendReminderDialog" :open.sync="showSendReminderDialog")

</template>

<script>
import AddIncome from '@/components/yezzabook/dialogs/income/addincome/AddIncome.vue'
import AddExpense from '@/components/yezzabook/dialogs/expense/addexpense/AddExpense.vue'
import SendReminder from '@/components/yezzabook/dialogs/SendReminder.vue'

export default {
  name: 'DashboardQuickActions',
  components: { AddIncome, AddExpense, SendReminder },
  data: () => ({
    showAddIncomeDialog: false,
    showAddExpenseDialog: false,
    showSendReminderDialog: false
  })
}
</script>

<style scoped>
</style>
